import React, { useContext, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { BlouseContext } from "../../../context/blouseContext";
import BlouseDisplay from "./blousedisplay";
import { useTranslation } from 'react-i18next';

const BlouseList=()=>{
    const [blouseList, setBlouseList] = useState("All");
    const {blouseData,itemsData,selectedBlouse}=useContext(BlouseContext);
    const [filterBlouse,setFilterBlouse]=useState("");
    const [filterSubBlouse,setFilterSubBlouse]=useState("");
    const { t } = useTranslation();
    const translatedFilter = t('main.fiter_buttons', { returnObjects: true });

    const FitlerBlouseData=itemsData.filter(each=>(
        each.name.toLowerCase().includes(filterBlouse.toLowerCase())
    ))
    const FitlerBlouseSubData=blouseData.filter(each=>(
        each.name.toLowerCase().includes(filterSubBlouse.toLowerCase())
    ))

    const filteredItems = blouseData.reduce((acc, category) => {
        if (category.name === blouseList) {
            acc.push(...category.items);
        }
        return acc;
        }, []);
    
    const handleSelect = (key) => {
        setBlouseList(key);
    };

    return(
        <>
          <div>
            <Col className="pt-1" lg={12}>
                <Button variant={blouseList === "All" ? "dark px-1":"outline-dark px-1"} size="sm"
                onClick={()=>handleSelect("All")}>{translatedFilter[0]}</Button>
                <Button variant={blouseList === "3 Dart" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("3 Dart")}>{translatedFilter[1]}</Button>
                <Button variant={blouseList === "4 Dart" ? "dark px-1":"outline-dark px-1"} size="sm"
                onClick={()=>handleSelect("4 Dart")}>{translatedFilter[2]}</Button>
                <Button variant={blouseList === "Princess" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("Princess")}>{translatedFilter[3]}</Button>
                <Button variant={blouseList === "Katori" ? "dark px-1":"outline-dark px-1"} size="sm"
                onClick={()=>handleSelect("Katori")}>{translatedFilter[4]}</Button>
                <Button variant={blouseList === "Sabyasachi" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("Sabyasachi")}>{translatedFilter[5]}</Button>
            </Col>
            </div>
            {blouseList === "All" ? (<>
                <div className="d-flex">
                <Col className="" >
                   <Form.Control type="text" 
                   onChange={(e)=>setFilterBlouse(e.target.value)}
                   placeholder="Search By Items..." />
                 </Col>
                 <Col className="mt-2 mx-1" lg={5} sm={5} md={5}>
                   <p className="text-dark px-1">{t('main.search_total')} <span>{FitlerBlouseData.length}</span></p>
                 </Col>
                 </div>
                 </>)
                 :
                 (<>
                 <div className="d-flex m-0">
                 <Col className="" >
                   <Form.Control type="text" 
                   onChange={(e)=>setFilterSubBlouse(e.target.value)}
                   placeholder="Search By Items..." />
                 </Col>
                 <Col className="mt-2" lg={4} sm={4} md={4}>
                   <p className="text-dark mx-2">{t('main.search_total')} {filteredItems.length}</p>
                 </Col>
                 </div>
                 </>)
                 }

             {blouseList === "All" ? (<>
                <div className="leftside_items">
                {FitlerBlouseData.map(each=>{
                    if(blouseList === "All"){
                        return(
                        <BlouseDisplay  
                        key={each.id}
                        icon={each.icon}
                        name={each.name}
                        data={each} >
                            {/* <p className="text-primary striped-pattern">Paid</p> */}
                    </BlouseDisplay>
                    )}
                })}
                
                 </div>
                 </>)
                 :
                 (<>
                 <div className="leftside_items">
                 {filteredItems.map(each=>(
                   each.name.toLowerCase().includes(filterSubBlouse.toLowerCase()) &&
                    <BlouseDisplay key={each.id}
                        icon={each.icon}
                        name={each.name}
                        data={each}>
                    </BlouseDisplay>
                ))}
                 
                 </div>
                 </>)
                 }
                 
            
            
            
        </>
    )
}
export default BlouseList